const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyDice1dDyAz4XTDgS8HE3bD3_biQmPK_yo',
    authDomain: 'one-playlist-fb.firebaseapp.com',
    databaseURL: 'https://one-playlist-fb.firebaseio.com',
    projectId: 'one-playlist-fb',
    storageBucket: 'one-playlist-fb.appspot.com',
    messagingSenderId: '114088280838',
    appId: '1:114088280838:web:c8586119b41b405fef9487',
    measurementId: 'G-NXFHCQ3T84',
};

const PLAYBACK = {
    PROGRESS_BAR_FREQUENCY: 500,
};

export default {
    LOCAL_STORAGE_APP_KEY: 'app',
    LOCAL_STORAGE_PARTY_LINK_TO_REDIRECT: 'party-link',
    FIREBASE_CONFIG,
    PLAYBACK,
};
